module.exports = __webpack_public_path__ + "img/ERI.1f109019.svg";